import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Partners.css';

const PARTNER_KEYS = [
  {
    key: 'montanaConseil',
    url: 'https://montana-conseil.fr/',
  },
  {
    key: 'trixConsulting',
    url: 'https://trix-consulting.fr/',
  },
  {
    key: 'liveGniarkgniark',
    url: 'https://live.gniarkgniark.fr/',
  },
  {
    key: 'parere',
    url: 'https://parere.fr/',
  },
  {
    key: 'nativid',
    url: 'https://nativid.fr/',
  },
];

function Partners() {
  const { t } = useTranslation();

  return (
    <section id="partenaires" className="partners section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('partners.title')}</h2>
          <p className="section-quick-answer">{t('partners.quickAnswer')}</p>
        </div>

        <div className="partners-grid">
          {PARTNER_KEYS.map((partner) => (
            <a
              key={partner.key}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="partners-card"
            >
              <h3 className="partners-card-title">{t(`partners.${partner.key}.name`)}</h3>
              <p className="partners-card-role">{t(`partners.${partner.key}.role`)}</p>
              <p className="partners-card-description">{t(`partners.${partner.key}.description`)}</p>
              <span className="partners-card-url">{partner.url.replace('https://', '').replace(/\/$/, '')}</span>
            </a>
          ))}
        </div>

        <p className="partners-cta">
          <Link to="/references/">{t('partners.viewReferences')}</Link>
        </p>
      </div>
    </section>
  );
}

export default Partners;
